// Horários como "HH:MM" e minutos desde 00:00.
import { t } from './i18n';

const p2 = (n: number) => String(n).padStart(2, '0');
export const toMin = (hm: string) => { const [h, m] = hm.split(':').map(Number); return h * 60 + m; };
export const fromMin = (m: number) => { const x = ((m % 1440) + 1440) % 1440; return `${p2(Math.floor(x / 60))}:${p2(x % 60)}`; };
export const endTime = (time: string, duration: number) => fromMin(toMin(time) + duration);
/** Duração: abaixo de 60 min em minutos ("30 min"); a partir de 60 min no formato HH:MM ("01:00", "03:25"). */
export const durLabel = (m: number) => (m < 60 ? t('{m} min', { m }) : `${p2(Math.floor(m / 60))}:${p2(m % 60)}`);
/** Duração em horas que não parece horário (0.69, padrão do texto 03 A6): "45 min", "5h", "21h", "1h30". Usado em Estudos (metas e tempo estudado). */
export const durHoras = (min: number) => {
  const m = Math.round(min);
  if (m < 60) return t('{m} min', { m });
  const h = Math.floor(m / 60), r = m % 60;
  return r ? `${h}h${p2(r)}` : `${h}h`;
};
/** Texto do campo de duração: "30" abaixo de 60 min, "01:30" a partir de 60 min. */
export const durCampo = (m: number) => (m < 60 ? String(m) : `${p2(Math.floor(m / 60))}:${p2(m % 60)}`);
/** Lê uma duração digitada: "90", "1:30" ou "01:30" (também aceita "1h30", "1.30"). Devolve minutos ou null. */
export function parseDur(s: string): number | null {
  const x = s.trim().toLowerCase().replace(/\s+/g, '').replace(/min$/, '').replace(/[h.,]/g, ':').replace(/:$/, ':00');
  if (!x) return null;
  let n: number;
  if (x.includes(':')) {
    const [a, b] = x.split(':');
    if (!/^\d{1,2}$/.test(a) || !/^\d{1,2}$/.test(b) || Number(b) > 59) return null;
    n = Number(a) * 60 + Number(b);
  } else {
    if (!/^\d{1,4}$/.test(x)) return null;
    n = Number(x);
  }
  return n > 0 && n <= 24 * 60 ? n : null;
}
/** Lê um horário digitado: "13:30", "1330", "9", "9:05", "13h30". Devolve { h, m } ou null. */
export function parseHora(s: string): { h: number; m: number } | null {
  const x = s.trim().toLowerCase().replace(/\s+/g, '').replace(/[h.,]/g, ':');
  let h: number, m: number;
  if (x.includes(':')) {
    const [a, b = ''] = x.split(':');
    if (!/^\d{1,2}$/.test(a) || !/^\d{0,2}$/.test(b)) return null;
    h = Number(a); m = b ? Number(b) : 0;
  } else {
    if (!/^\d{1,4}$/.test(x)) return null;
    if (x.length <= 2) { h = Number(x); m = 0; } else { h = Number(x.slice(0, -2)); m = Number(x.slice(-2)); }
  }
  return h < 24 && m < 60 ? { h, m } : null;
}

/** Divide a atividade pelas pausas: [{de, ate}] para os blocos de atividade. */
export function blocos(time: string, duration: number, pauses: { at: string; min: number }[]) {
  const ini = toMin(time), fim = ini + duration;
  const ps = pauses.map(p => ({ a: toMin(p.at), b: toMin(p.at) + p.min })).filter(p => p.a > ini && p.a < fim).sort((x, y) => x.a - y.a);
  const out: { de: string; ate: string }[] = [];
  let cur = ini;
  for (const p of ps) { if (p.a > cur) out.push({ de: fromMin(cur), ate: fromMin(p.a) }); cur = Math.max(cur, p.b); }
  if (cur < fim) out.push({ de: fromMin(cur), ate: fromMin(fim) });
  return out;
}
